<dropdown [options]="zones" [(ngModel)]="selected"></dropdown>
